export const AI_PRICES = {
     INPUT_NORMAL: 2.5, // per 1M tokens
     INPUT_CACHED: 1.25, // per 1M tokens
     OUTPUT: 10.0, // per 1M tokens
}

export interface Top3User {
     id: number
     name: string
     tokens: number
}

export interface UserQuota {
     id: number
     name: string
     username: string
     dailyUsed: number
     dailyLimit: number | null
     monthlyUsed: number
     monthlyLimit: number | null
     totalTokens: number
     periodInput: number
     periodCached: number
     periodOutput: number
     periodTotal: number
     periodCost: number
}

export interface AiGlobalStats {
     totalTokens: number
     inputNormal: number
     cachedTokens: number
     outputTokens: number
     totalCost: number
     documentsCount: number
}
